export const PRODUCT_LINE_ACCENT = {

  Chromalux: 'gold',

  Fortilux: 'blue',

  Verdalux: 'green',

  Formalux: 'navy',

};



export const CASE_STUDIES = [

  {

    id: 'rpet-one-pellet',

    title: 'One-Pellet rPET Solution',

    summary: 'Streamlining color, functionality & efficiency in recycled PET packaging.',

    productLine: 'Verdalux',

    polymer: 'rPET',

    tag: 'SUSTAINABILITY',

    accent: 'green',

    image: 'case-study-rpet-one-pellet.png',

  },

  {

    id: 'nir-black-closure',

    title: 'NIR-Sortable Black PE Closure',

    summary: 'Carbon-black alternative with full MRF sortability and laser-marking compatibility.',

    productLine: 'Verdalux',

    polymer: 'PE',

    tag: 'FAST GROWING',

    accent: 'green',

    image: 'case-study-nir-black-closure.png',

  },

  {

    id: 'pet-swirl-elimination',

    title: 'Elimination of Swirling in PET Food Packaging',

    summary: 'Nano-scale dispersion eliminates gels and flow marks at source on high-speed lines.',

    productLine: 'Chromalux',

    polymer: 'PET',

    tag: 'HIGH URGENCY',

    accent: 'gold',

    image: 'case-study-pet-swirl-elimination-v2.png',

  },

  {

    id: 'uv-barrier-rpet',

    title: 'PET Packaging With UV Barrier and 100% rPET',

    summary: 'Color integrity maintained across multiple mechanical recycling cycles.',

    productLine: 'Verdalux',

    polymer: 'rPET',

    tag: 'REGULATORY DRIVEN',

    accent: 'green',

    image: 'case-study-uv-barrier-rpet.png',

  },

  {

    id: 'laser-marking-dual',

    title: 'Dual-Format Laser-Marking Innovation',

    summary: 'Compound and masterbatch solutions delivering superior readability on automotive trim.',

    productLine: 'Formalux',

    polymer: 'PP',

    tag: 'TRANSFORMATIVE',

    accent: 'navy',

    image: 'case-study-laser-marking-dual.png',

  },

  {

    id: 'hdpe-dairy-reformulation',

    title: 'HDPE Packaging Reformulation for Liquid Dairy',

    summary: 'Migration-compliant color masterbatch with stable let-down across converter networks.',

    productLine: 'Chromalux',

    polymer: 'HDPE',

    tag: 'EMERGING',

    accent: 'gold',

    image: 'case-study-hdpe-dairy-reformulation.png',

  },

  {

    id: 'o2-scavenger-food',

    title: 'O₂ Barrier-Compatible Masterbatch for Food Packaging',

    summary: 'Oxygen scavenger compatibility without IV drop or color migration in PET bottles.',

    productLine: 'Fortilux',

    polymer: 'PET',

    tag: 'HIGH GROWTH',

    accent: 'blue',

    image: 'case-study-o2-scavenger-food.png',

  },

  {

    id: 'matte-in-mold',

    title: 'In-Molded Premium Matte & Frost Effect',

    summary: 'Design freedom without mold changes — premium finish for consumer durable goods.',

    productLine: 'Formalux',

    polymer: 'ABS',

    tag: 'INNOVATION',

    accent: 'navy',

    image: 'case-study-matte-in-mold.png',

  },

];

